import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useCustomerByUserId(userId) {
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    if (!userId) {
      setCustomer(null);
      setLoading(false);
      return () => {};
    }
    setLoading(true);
    const db = firebase.firestore();
    const unsubscribe = db.collection('customers')
      .where('userId', '==', userId)
      .limit(1)
      .onSnapshot(
        (snap) => {
          setCustomer(snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() });
          setLoading(false);
        },
        (err) => {
          console.error('[useCustomerByUserId] Failed:', err);
          setCustomer(null);
          setLoading(false);
        }
      );
    return () => unsubscribe();
  }, [userId]);

  return [loading, customer];
}
